
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { PaymentRepository } from '../../../domain/repositories/payment/payment.repository';
import {
  CheckPaymentStatusInput,
  CheckPaymentStatusResult,
  PaymentMethodType,
  PaymentStatusInfo,
  StartPaymentInput,
  StartPaymentResult,
} from '../../../domain/interfaces/payment/payment.interface';
import { HttpClientService } from '../../services/http-client/http-client.service';
import { API_ENDPOINTS } from '../../config/api.config';

const DEFAULT_PRODUCT = 'Autos';

interface StartPaymentRequestDto {
  product: string;
  input: {
    recordId: string;
    type: PaymentMethodType;
    ipAddress: string;
    userAgent: string;
  };
}

interface StartPaymentResponseDataDto {
  status: PaymentStatusInfo;
  requestId: string;
  processUrl?: string;
}

interface CheckPaymentStatusRequestDto {
  product: string;
  input: { recordId: string };
}

@Injectable()
export class PaymentRepositoryImplementation extends PaymentRepository {
  private readonly http = inject(HttpClientService);

  override startPayment(input: StartPaymentInput): Observable<StartPaymentResult> {
    const dto: StartPaymentRequestDto = {
      product: DEFAULT_PRODUCT,
      input: {
        recordId: input.recordId,
        type: input.type,
        ipAddress: '0.0.0.0',
        userAgent: navigator.userAgent,
      },
    };

    return this.http
      .post<StartPaymentResponseDataDto>(API_ENDPOINTS.payments.start, dto)
      .pipe(
        map((response) => ({
          status: response.data.status,
          requestId: response.data.requestId,
          processUrl: response.data.processUrl ?? null,
        })),
      );
  }

  override checkPaymentStatus(input: CheckPaymentStatusInput): Observable<CheckPaymentStatusResult> {
    const dto: CheckPaymentStatusRequestDto = {
      product: DEFAULT_PRODUCT,
      input: { recordId: input.recordId },
    };

    return this.http
      .post<CheckPaymentStatusResult>(API_ENDPOINTS.payments.token, dto)
      .pipe(map((response) => response.data));
  }
}
